var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3.25C9.98122 3.25 8.75 4.48122 8.75 6V6.5C8.75 6.91421 9.08579 7.25 9.5 7.25C9.91421 7.25 10.25 6.91421 10.25 6.5V6C10.25 5.30964 10.8096 4.75 11.5 4.75H18.5C19.1904 4.75 19.75 5.30964 19.75 6V13C19.75 13.6904 19.1904 14.25 18.5 14.25H18C17.5858 14.25 17.25 14.5858 17.25 15C17.25 15.4142 17.5858 15.75 18 15.75H18.5C20.0188 15.75 21.25 14.5188 21.25 13V6C21.25 4.48122 20.0188 3.25 18.5 3.25H11.5Z",
    fill: "#00322E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8.25C4.98122 8.25 3.75 9.48122 3.75 11V18C3.75 19.5188 4.98122 20.75 6.5 20.75H13.5C15.0188 20.75 16.25 19.5188 16.25 18V11C16.25 9.48122 15.0188 8.25 13.5 8.25H6.5ZM5.25 11C5.25 10.3096 5.80964 9.75 6.5 9.75H13.5C14.1904 9.75 14.75 10.3096 14.75 11V18C14.75 18.6904 14.1904 19.25 13.5 19.25H6.5C5.80964 19.25 5.25 18.6904 5.25 18V11Z",
    fill: "#00322E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCopy);
export default __webpack_public_path__ + "static/media/icn_copy.ac726dd343efeb8a327f7ff623653b15.svg";
export { ForwardRef as ReactComponent };